export default __webpack_public_path__ + "static/media/megax-header.35bfd896.png";